import { render, staticRenderFns } from "./personEdit.vue?vue&type=template&id=b87b8972&scoped=true&"
import script from "./personEdit.vue?vue&type=script&lang=tsx&"
export * from "./personEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./personEdit.vue?vue&type=style&index=0&id=b87b8972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b8972",
  null
  
)

export default component.exports